/**
 * @param {unknown} blob
 * @returns {blob is Blob}
 */
export function isUsableSignatureBlob(blob) {
    return blob instanceof Blob && blob.size > 0
}

/**
 * Fetch a signature image for receipts / form preload.
 * Never throws — returns null when missing, empty, or otherwise unusable.
 *
 * @param {string | null | undefined} url
 * @param {{ orderId?: unknown, context?: string }} [meta]
 * @returns {Promise<Blob | null>}
 */
export async function fetchSignatureBlob(url, meta = {}) {
    if (url == null || String(url).trim() === "") {
        return null
    }

    const info = {
        url: String(url),
        orderId: meta.orderId ?? null,
        context: meta.context ?? null,
    }

    try {
        const res = await fetch(String(url))
        if (!res.ok) {
            console.log("Signature unavailable; continuing without it.", {
                ...info,
                status: res.status,
                statusText: res.statusText,
            })
            return null
        }

        const blob = await res.blob()
        if (!isUsableSignatureBlob(blob)) {
            console.log("Signature unavailable; continuing without it.", {
                ...info,
                reason: "empty_or_invalid_blob",
                size: blob?.size ?? null,
                type: blob?.type ?? null,
            })
            return null
        }

        return blob
    } catch (error) {
        console.log("Signature unavailable; continuing without it.", {
            ...info,
            reason: "fetch_error",
            error,
        })
        return null
    }
}
